import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import * as api from './Api'
import hasPermission from './hasPermission';
import iviewArea from 'iview-area';
import {HOST} from './config';
import iView from 'iview'
import 'iview/dist/styles/iview.css';
import '../static/font/iconfont.css'
import '../static/reset.css'
import '../static/reIview.css'

Vue.use(iView);
Vue.use(hasPermission);
Vue.use(iviewArea);

let token = sessionStorage.getItem('access_token');

const instance = axios.create({
    baseURL: HOST,
});

Vue.config.productionTip = false;
Vue.api = Vue.prototype.$api = api;
Vue.http = Vue.prototype.$http = instance;

if (!token) {
    instance.post('/oauth/token', {
        grant_type: 'client_credentials',
        client_id: 1,
        client_secret: 'IRwipTloBj54dYeznekQt2shYHaTrmeIIRXq0bQb',
        scope: ''
    }).then(res => {
        store.dispatch('setToken','Bearer ' + res.data.access_token);
        sessionStorage.setItem('access_token', 'Bearer ' + res.data.access_token);
        instance.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.access_token;
    });
} else {
    instance.defaults.headers.common['Authorization'] = sessionStorage.getItem('access_token');
    instance.defaults.timeout = 15000;
    Vue.http = Vue.prototype.$http = instance;
}

new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js